<template>
    <ConfirmDialog group="dialog" />
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{$t('notice1.view.ViewHeading')}}</strong>
                </h4>
               
                <div class="p-field p-grid">
                    <label for="category_name_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('notice1.view.ViewTitle') }}</label>
                    <div class="p-col-12 p-md-10">
                        <p>{{ mydata.title }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="title_en" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('notice1.view.CreatedDate') }}</label>
                    <div class="p-col-12 p-md-10">
                        <p>{{ dateformat(mydata.created_date) }}</p>
                    </div>
                </div>

                <div class="p-field p-grid p-align-start">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('notice1.view.ViewDescription') }}</label>
                    <div class="p-col-12 p-md-10">
                        <p v-html="mydata.description"></p>
                    </div>
                </div>

                <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: left;">
                    <router-link @mouseenter="editnotice($route.params.id)" :to="'/edit-notice/' + $route.params.id">
                        <Button :label="$t('notice1.view.Edit')" class="p-button-outlined p-button-help p-mr-2 p-mb-2" id="editBlack" icon="pi pi-pencil" iconPos="left"> </Button>
                    </router-link>
                    <Button @click="del($route.params.id)" :label="$t('notice1.view.Delete')" class="p-button-outlined p-button-danger p-mr-2 p-mb-2" icon="pi pi-trash" iconPos="left"> </Button>
                </div><br><br>
                <!-- <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                    <Button @click="del($route.params.id)" :label="$t('notice1.view.Delete')" class="p-button-outlined p-button-danger p-mr-2 p-mb-2"> </Button>
                </div> -->
                <div class="p-d-flex p-jc-end p-ai-center" style="float: right;">
                    <Button :label="$t('notice1.view.Back')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button p-mr-2 p-mb-2" @click="$router.go(-1)" style="background: white; color: black; margin-top: -38px"></Button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import NoticeService from '../../service/API/NoticeService';
// import {useRouter} from 'vue-router'
import moment from 'moment';
export default {
    data() {
        return {
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            mydata: {
                title: '',
                description: '',
                created_date: '',
            },
            id:''
        };
    },
    created() {
        this.noticeService = new NoticeService();
    },
    methods: {
        del(id) {
            var self = this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'post', url: `api/v1/admin/notice/delete`, data: { notice_id: id } }).then(function () {   
                        // console.warn(res);
                        self.$router.push({ name: 'Notice' });
                        setTimeout(() => {
                            self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 })
                        }, 500);
                        
                    });
                    // this.$toast.add({ severity: 'info', summary: 'Deleted', detail: 'Deleted successfully', life: 3000 });
                    // self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });

                },
                // reject: () => {
                //     self.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                //     // this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                // },
            });
        },
        dateformat(value) {
            if (value) {
                return moment(String(value)).format('YYYY.MM.DD');
            }
        },
        editnotice(id) {
            this.noticeService.viewNotice(id).then((result) => {
                localStorage.setItem('desc', JSON.stringify(result[0]));
                // alert(res.result)
                // console.log(result[0].description)
            });
        },
    },
    mounted() {
        this.noticeService.viewNotice(this.$route.params.id).then((result) => {
            this.mydata.title = result[0].title;
            this.mydata.created_date = result[0].created_date;
            this.mydata.description = result[0].description;
            localStorage.setItem('desc', result[0].description);
            // console.log(result);
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}
.renderHtml {
    background-color: #fcfcfc;
    padding: 25px;
    border: 1px solid rgba(70, 77, 242, 0.2);
    border-radius: 5px;
    margin-top: 15px;
}

/* .p-d-flex.p-jc-end.p-ai-center.dual-btn {
    margin-top: 13px;
} */
button#editBlack {
    background: black;
    color: white;
}
</style>
